import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {Link} from 'react-router-dom';
import {compose, setPropTypes, withProps, withStateHandlers} from 'recompose';
import {withScriptjs, withGoogleMap, GoogleMap, Marker, Circle, InfoWindow, OverlayView} from 'react-google-maps';

import * as ImageUtils from '../../utils/Image';
import * as RouteUtils from '../../utils/Route';
import * as ObjectUtils from '../../utils/Property';
import * as ImageConst from '../../constants/Image';
import * as ObjectConst from '../../constants/Property';

import imgOffice from '../../static/img/office.jpg';

const propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
    zoom: PropTypes.number,
    centerLat: PropTypes.number,
    centerLng: PropTypes.number,
    searchLink: PropTypes.string,
    isContactsMap: PropTypes.bool,
    isDoNotHandleClickMarker: PropTypes.bool
};

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    code: state.languages.currentLanguage.code,
    defaultLat: state.configuration.main.defaultLat,
    defaultLng: state.configuration.main.defaultLng
});

const getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -(height + 70),
});

const Map = compose(
    setPropTypes(propTypes),
    connect(mapStateToProps),
    withProps(props => ({
        googleMapURL: "/static/map/script.js",
        loadingElement: <div style={{height: '100%'}} />,
        containerElement: <section id={props.id} className={props.className ? props.className : ''} />,
        mapElement: <div style={{height: '100%'}} />,
    })),
    withStateHandlers(
        () => ({
            openWindowId: ''
        }), {
            onToggleOpen: ({openWindowId}) => id => ({
                openWindowId: id !== openWindowId ? id : ''
            })
        }
    ),
    withScriptjs,
    withGoogleMap
)(props => {
    const {code, i18n, isDoNotHandleClickMarker} = props;
    let zoom = props.zoom != null ? props.zoom : 8;
    let centerLat = props.centerLat != null ? props.centerLat : props.defaultLat;
    let centerLng = props.centerLng != null ? props.centerLng : props.defaultLng;

    let mainMarker;
    if (props.lat !== undefined && props.lat !== 0) {
        if (props.circle) {
            mainMarker = (<Circle
                key={'as'}
                options={
                    {
                        strokeColor: '#FF0000',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#FF0000',
                        fillOpacity: 0.35,
                    }
                }
                center={{lat: props.lat, lng: props.lng}}
                radius={150}
            />);
        } else {
            mainMarker = (
                <Marker
                    key={'as'}
                    onClick={() => props.onToggleOpen('as')}
                    position={{lat: props.lat, lng: props.lng}}
                >
                    {props.isContactsMap && props.openWindowId === 'as' &&
                    <InfoWindow onCloseClick={() => props.onToggleOpen('as')}>
                        <div className="map_info-window">
                            <div className="w_link">
                                <div className="w_img" style={{backgroundImage: `url(${imgOffice})`}} />
                            </div>
                        </div>
                    </InfoWindow>}
                </Marker>
            );
        }
    }

    return (
        <GoogleMap
            defaultZoom={zoom}
            onClick={props.onMapClick}
            center={{lat: centerLat, lng: centerLng}}
        >
            {props.objects !== undefined && props.objects.map(object => (
                <Marker
                    key={object.id}
                    position={{lat: object.location.latitude, lng: object.location.longitude}}
                    onClick={() => isDoNotHandleClickMarker ? null : props.onToggleOpen(object.id)}
                >
                    {object.id === props.openWindowId && <OverlayView
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                        getPixelPositionOffset={getPixelPositionOffset}
                        position={{lat: object.location.latitude, lng: object.location.longitude}}
                    >
                        <div className={classnames('last-item', {
                            'bage': object.props.rangeType === ObjectConst.RANGE_TYPE.EXCLUSIVE
                        })}>
                            <div className="item-inner price-tm">
                                <Link
                                    target="_blank"
                                    className=""
                                    to={{
                                        pathname: RouteUtils.getPropertyPathname(object.id),
                                        search: props.searchLink !== undefined ? props.searchLink : ''
                                    }}
                                >
                                    <div
                                        className="last-item-img"
                                        style={{
                                            backgroundImage: `url(${object.meta.images !== null ?
                                                ImageUtils.getSrc(object.meta.images[0].id, ImageConst.TYPE.THUMBS) : ''})`
                                        }}
                                    >
                                        {ObjectUtils.getPriceRentBlock(object, i18n)}
                                    </div>
                                    <div className="last-item-title">
                                        {ObjectUtils.getDisplayName(code, object)}
                                    </div>
                                </Link>

                                <div className="last-item-footer">
                                    <div className="icons-boxed">
                                        <div className="icons-boxed">
                                            <span className="icon icon-person">{object.props.countGuest}</span>
                                            <span className="icon icon-bad">{object.props.countBeds}</span>
                                            <span className="icon icon-quadrature">{object.props.area}</span>
                                            <span className="icon icon-bath">{object.props.countBathrooms}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="inner_pointer">
                                    <div className="pointer_left">
                                        <div className="left_content" />
                                    </div>
                                    <div className="pointer_right">
                                        <div className="right_content" />
                                    </div>
                                </div>

                                <div className="inner_close" onClick={() => props.onToggleOpen(object.id)}>
                                    <img
                                        alt=""
                                        draggable="false"
                                        src="https://maps.gstatic.com/mapfiles/api-3/images/mapcnt6.png"
                                    />
                                </div>
                            </div>
                        </div>
                    </OverlayView>}
                </Marker>
            ))}

            {mainMarker !== undefined && mainMarker}
        </GoogleMap>
    );
});

export default Map;



// WEBPACK FOOTER //
// ./src/components/Base/Map.js